import React from "react";
import { connect } from "react-redux";
import images from "../../../ressources/images";

function Maintenance({ config }) {
  console.log({ config });

  const picture = config.maintenance_picture || images.maintenance;

  return (
    <div>
      <img
        src={picture}
        style={{
          margin: "0 auto",
          width: "100%",
          maxWidth: "60rem",
          display: "block",
        }}
        alt=""
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  config: state.config,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Maintenance);
